import Notification from './container';

export default Notification;
